(() => {
  if (window.BerryPuffHomeConfigurator) {
    window.BerryPuffHomeConfigurator.init(document);
    return;
  }
  const selector = '[data-bp-home-configurator]';
  const controllers = new WeakMap();
  const sectionRoots = (scope) => {
    const roots = [...scope.querySelectorAll(selector)];
    if (scope.matches?.(selector)) roots.unshift(scope);
    return roots;
  };
  const init = (scope = document) => {
    sectionRoots(scope).forEach((root) => {
      if (controllers.has(root)) return;
      const radios = [...root.querySelectorAll('.bp-home-configurator__option input[type="radio"]')];
      const panels = [...root.querySelectorAll('[data-bp-config-panel]')];
      if (!radios.length || !panels.length) return;
      const controller = new AbortController();
      controllers.set(root, controller);
      const status = root.querySelector('[data-bp-config-status]');
      const select = (value, fromUser = false) => {
        const selected = panels.find((panel) => panel.dataset.bpConfigPanel === value);
        if (!selected) return;
        panels.forEach((panel) => { panel.hidden = panel !== selected; });
        if (fromUser && status) {
          status.textContent = (root.dataset.selectionStatus || '__TITLE__').replace('__TITLE__', selected.dataset.title || '');
        }
      };
      select(radios.find((radio) => radio.checked)?.value || radios[0].value);
      root.dataset.bpConfigEnhanced = 'true';
      root.addEventListener('change', (event) => {
        if (!radios.includes(event.target) || !event.target.checked) return;
        select(event.target.value, true);
      }, { signal: controller.signal });
    });
  };
  const destroy = (scope) => {
    sectionRoots(scope).forEach((root) => {
      controllers.get(root)?.abort();
      controllers.delete(root);
      delete root.dataset.bpConfigEnhanced;
      root.querySelectorAll('[data-bp-config-panel]').forEach((panel) => { panel.hidden = false; });
    });
  };
  window.BerryPuffHomeConfigurator = { init, destroy };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();

